import { render } from "./IconPlus.vue?vue&type=template&id=e5dfad1c&scoped=true"
import script from "./IconPlus.vue?vue&type=script&lang=js"
export * from "./IconPlus.vue?vue&type=script&lang=js"

import "./IconPlus.vue?vue&type=style&index=0&id=e5dfad1c&lang=scss&scoped=true"

import exportComponent from "/builds/fenix/ais-abr/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5dfad1c"]])

export default __exports__